export default __webpack_public_path__ + "static/SanFranciscoText-Bold-8ef74dd6569547713d3554b7dbf0c0a0.woff";